import React, {Component} from 'react';
import btnclasses from './Button.module.scss';
import classes from './Landing.module.scss';
import {Link} from 'react-router-dom';

let currency = '';

class Landing extends Component {
    constructor(props){
        super(props);
        this.state ={
            currency: '',
        }
        this.handleChange = this.handleChange.bind(this);
    };

    handleChange(event){
     
        this.setState({
            currency : event.target.value,
        });
        
       
    }

    list(currency){
        console.log(currency);
        if(this.state.currency === '' || this.state.currency === undefined){
            return('Please select a currency first');
        }else{
            return(
                <div className={classes.Flex}>
                    <Link  to={'/invoice/' +this.state.currency+  '/unit'}>
                        <button className={btnclasses.Button}>
                         Invoice<br/>
                         Generator (Unit)                
                         </button>
                    </Link>

                    <Link  to={'/invoice/'+this.state.currency+'/quantity'} >
                        <button className={btnclasses.Button}>
                         Invoice<br/>
                         Generator (Quanity)                
                         </button>
                    </Link>

                    <Link  to={'/receipt/'+this.state.currency+'/unit'} >
                        <button className={btnclasses.Button}>
                         Receipt<br/>
                         Generator (Unit)               
                         </button>
                    </Link>

                    <Link  to={'/receipt/'+this.state.currency+'/quantity'} >
                        <button className={btnclasses.Button}>
                         Receipt<br/>
                         Generator (Quantity)                
                         </button>
                    </Link>
                    
                </div>
            );
        }
    }
        
        


    render(){
        return(
            <div>
            <header>
                <h2> Welcome</h2>
                <Link to={'/'}>
                <p>LOGOUT</p>
                </Link>
            </header>            
            <div className={classes.Grid} >

                    <div>
                        <h1>Select Currency</h1>
                            <div className={classes.whole}>
                               
                                <div className={classes.selection}>
                                    <input id="cedis" name="currency"  value="GHS" type="radio"  onClick={this.handleChange}/>
                                    <label htmlFor='cedis'>CEDIS (GHS)</label>
                                </div>
                                <div className={classes.selection}>
                                    <input id="dollar" name="currency" value="USD" type="radio"  onClick={this.handleChange}/>
                                    <label htmlFor="dollar">DOLLAR (USD)</label>
                                </div>
                                <div className={classes.selection}>
                                    <input id="pound" name="currency" value="GBP" type="radio"  onClick={this.handleChange}/>
                                    <label htmlFor="pound">POUND (GBP)</label>
                                </div>                                        
                            </div>
                
                    </div>
                
               
                    {this.list(currency)}
                
                </div>
              
                </div>
         
        );
    }
}

export default Landing;